import { render, staticRenderFns } from "./SellingPoints.vue?vue&type=template&id=795a5514"
import script from "./SellingPoints.vue?vue&type=script&lang=js"
export * from "./SellingPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports